import { WarehouseService } from './../../../services/warehouse/warehouse.service';
import { CatalogsService } from './../../../services/catalogs/catalogs.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-check-modal',
  templateUrl: './check-modal.component.html',
  styleUrls: ['./check-modal.component.scss'],
  providers: [WarehouseService, CatalogsService]
})
export class CheckModalComponent implements OnInit {

  public user: User;
  id;
  select;
  busy: boolean = false;
  modalRef;
  posicion;
  inputChecked;
  btnCrear;

  toastNoIdentificadorUnico;
  toastIdentificadorUnico;
  public toasterconfig: ToasterConfig = new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private wareHouseService: WarehouseService,
    private catalogos: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.translate.get('texto.toastNoIdentificadorUnico').subscribe(
      text => {
        this.toastNoIdentificadorUnico = text;
      });
    this.translate.get('texto.toastIdentificadorUnico').subscribe(
      text => {
        this.toastIdentificadorUnico = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  closeModal() {
    this.activeModal.close('cancelar');
  }

  verificar(valor, mensajeRes) {
    this.busy = true;
    const idPosicion = this.id; 
    const select = this.select[0].posicionOc.id;
    this.wareHouseService.checkProductOnASN(idPosicion, select, valor).subscribe(
      data => {
        this.busy = false;
        this.posicion = data.posicion_oc;
        if (this.posicion.length === 0) {
          this.toasterService.pop('error', this.toastNoIdentificadorUnico + ', ' + valor);
          this.open(mensajeRes);
        } else {
          this.toasterService.pop('success', '', this.toastIdentificadorUnico + ',' + valor);
        }
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }


  open(content) {
    this.modalRef = this.modalService.open(content, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRef.result.then((result) => {
      if (result === 'cancelar') {
        this.modalRef.close();
        this.closeModal();
        this.inputChecked.checked = false;
        this.inputChecked.className = 'awesome';
      } else {
        this.modalRef.close();
      }
    }).catch((error) => {
      // console.log(error);
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  terminar() {
    this.inputChecked.checked = true;
    this.inputChecked.className = 'check';
    this.activeModal.close('terminar');
  }

}






// WEBPACK FOOTER //
// ./src/app/pages/warehouse/check-modal/check-modal.component.ts